import { Box, Typography } from "@mui/material";
import styles from "../css/GadgetInformation.module.css";

interface GadgetInformationProps {
  children: React.ReactNode,
  headerText: string,
  infoText: string
}

export const GadgetInformation = ({headerText, infoText, children}: GadgetInformationProps) => {
    return (
      <>
        <Typography variant="h2" className={styles.headerText}>{headerText}</Typography>
        <Box>
            <Box className={styles.inofTextContainer}>
                <Typography variant="h3" className={styles.infoText}>{infoText}</Typography>
            </Box>
            <Box p={2} className={styles.childrenContainer}>
                {children}
            </Box>
        </Box>
      </>
    );
};